import { useTranslation } from "react-i18next";
import { Text } from "../../../components/Text";
import { Flex } from "../../../components/Flex";
import { standardDate } from "../../../utils/Date";
import { useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { AtiraIcon } from "../../../components/AtiraIcon";
import { Spacing } from "../../../theme/Spacing";
import styled from "styled-components";
import { faTag } from "@fortawesome/free-solid-svg-icons/faTag";
import { faCalendarDay } from "@fortawesome/free-solid-svg-icons/faCalendarDay";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons/faXmarkCircle";
import { faCircle } from "@fortawesome/free-regular-svg-icons/faCircle";
import { BaseTask } from "../../../model/task/Task";
import { renderHighlight } from "../utils/searchHighlight";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faTextWidth } from "@fortawesome/free-solid-svg-icons/faTextWidth";

const IconWrapper = styled(Flex)`
  vertical-align: middle;
  margin-inline-end: ${Spacing.xs};
  display: inline-flex;
  justify-content: center;
  width: 1rem;
`;

type Props = {
  task: BaseTask;
};

export const SearchCardTask: React.FC<Props> = ({ task }) => {
  const { t } = useTranslation();

  const user = useAppSelector(userSliceSelectors.selectLoggedInUser)!;

  return (
    <Flex flexDirection="column" gap="s" flex={1}>
      <Text className="atira-search-text">
        <IconWrapper>
          <AtiraIcon icon={faCheck} />
        </IconWrapper>
        <strong>{t("common.name")}: </strong>
        <span>{renderHighlight(task, "name") || task.name}</span>
      </Text>

      {task?.kind ? (
        <Text className="atira-search-text">
          <IconWrapper>
            <AtiraIcon icon={faTag} />
          </IconWrapper>
          <strong>{t("common.kind")}: </strong>
          <span>
            {renderHighlight(task, "kind") ||
              t(`common.${task.kind.toLowerCase()}_task`)}
          </span>
        </Text>
      ) : null}

      <Text className="atira-search-text">
        <IconWrapper>
          <AtiraIcon icon={faCircle} />
        </IconWrapper>
        <strong>{t("common.done")}: </strong>
        <AtiraIcon
          icon={task?.done ? faCheckCircle : faXmarkCircle}
          color={task?.done ? "success" : "danger"}
        />
      </Text>

      {task?.description ? (
        <Text className="atira-search-text">
          <IconWrapper>
            <AtiraIcon icon={faTextWidth} />
          </IconWrapper>
          <strong>{t("common.description")}: </strong>
          <span>
            {renderHighlight(task, "description") || task.description}
          </span>
        </Text>
      ) : null}

      {task?.deadline ? (
        <Text className="atira-search-text">
          <IconWrapper>
            <AtiraIcon icon={faCalendarDay} />
          </IconWrapper>
          <strong>{t("common.deadline")}: </strong>
          <span>
            {renderHighlight(task, "deadline") ||
              standardDate<string>(task.deadline, user, true)}
          </span>
        </Text>
      ) : null}
    </Flex>
  );
};
